(function(angular){
    'use strict';
    angular.module('MW.ContactManager.ActiveOnFormDropdown', ['MW.Framework.SingleSelectDropdownMenu'])
    .controller('FormDropdownController', ['$element', '$timeout', FormDropdownController])
    .directive('activeOnFormDropdown', [function(){
        return {
            restrict: 'E',
            template: '<single-select-dropdown-menu select-options="formDropdownController.selectOptions" selected-option="formDropdownController.selectedOption" dropdown-label="No Selection" selection-changed-callback="formDropdownController.changedCallback(selectedOption)", translate-elements></single-select-dropdown-menu>',
            controllerAs: 'formDropdownController',
            controller: 'FormDropdownController',
            bindToController: true,
            scope: {
                selectOptions: '=',
                selectedOption: '=',
                dropdownLabel: '@',
                selectionChangedCallback: '&'
            }
        };
    }]);

    function FormDropdownController($element, $timeout){
        this.$timeout = $timeout;
        this.$element = $element;
    }

    FormDropdownController.prototype.changedCallback = function changedCallback(selectedOption){
        this.selectionChangedCallback({selectedType: selectedOption});
        this.scrollToElement();
    };

    FormDropdownController.prototype.scrollToElement = function scrollToElement(){
        var offset = angular.copy(this.$element.offset().top);
        this.$timeout(function scroll(){
            angular.element(window).scrollTop(offset);
        }.bind(this), 0);
    };
}(window.angular));
